import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import getDataPoint from '../utils/getDataPoint';
import { translate } from './Translate';
import { DataStore, TranslationStore } from '../stores';
import { ShareClass } from '../models/entity';

const ResultsMetaWrapper = styled<any, any>('div')`
    ${propStyles};
    &:empty {
        display: none;
    }
`;

ResultsMetaWrapper.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'body',
    fontWeight: 'normal',
    fontSize: 'sm',
    paddingX: 'md',
    paddingY: 'md',
    color: 'body',
};

const ResultsMetaSummary = styled<any, any>('div')`
    ${propStyles};
`;

ResultsMetaSummary.defaultProps = {};

const ResultsMetaAsAtDate = styled<any, any>('div')`
    ${propStyles};
`;

ResultsMetaAsAtDate.defaultProps = {};

const rightAlignStyleProps = {
    order: 1,
    margin: '0 0 0 auto',
};

interface ResultsMetaProps {
    theme?: any;
    dataStore?: DataStore;
    translationStore?: TranslationStore;
    shareClasses: Array<ShareClass>;
}

@inject('dataStore')
@inject('translationStore')
@observer
class ResultsMeta extends Component<ResultsMetaProps> {
    @computed
    get resultsMeta() {
        const { resultsMeta = {} } = this.props.dataStore.config.explorer || {};
        return resultsMeta;
    }

    @computed
    get resultSummary() {
        return this.resultsMeta.resultSummary;
    }

    @computed
    get asAtDate() {
        return this.resultsMeta.asAtDate;
    }

    @computed
    get asAtDateValue() {
        const { dataStore, translationStore } = this.props;
        const [firstShareClass] = this.props.shareClasses;
        const { label = '', data = {} as any } = this.asAtDate;
        const value = getDataPoint({
            dataStore,
            dataConfig: data,
            shareClass: firstShareClass,
            locale: this.props.dataStore.culture,
        });

        const asAtDateValue = translate(translationStore, label, {
            value,
        });

        return asAtDateValue;
    }

    @computed
    get resultSummaryValue() {
        const { dataStore, translationStore } = this.props;
        const { label = '' } = this.resultSummary;
        const { total = 0, funds = [] } = dataStore;

        const resultSummaryValue = translate(translationStore, label, {
            count: funds.length,
            total,
        });

        return resultSummaryValue;
    }

    render() {
        const { theme } = this.props;
        return (
            <ResultsMetaWrapper {...theme.ResultsMetaWrapper}>
                {this.resultSummary && (
                    <ResultsMetaSummary
                        {...(this.resultSummary.align === 'right' &&
                            rightAlignStyleProps)}
                        {...theme.ResultsMetaSummary}
                    >
                        {this.resultSummaryValue}
                    </ResultsMetaSummary>
                )}
                {this.asAtDate && (
                    <ResultsMetaAsAtDate
                        {...(this.asAtDate.align === 'right' &&
                            rightAlignStyleProps)}
                        {...theme.ResultsMetaAsAtDate}
                    >
                        {this.asAtDateValue}
                    </ResultsMetaAsAtDate>
                )}
            </ResultsMetaWrapper>
        );
    }
}

export default withTheme(ResultsMeta);



// WEBPACK FOOTER //
// ./src/Components/ResultsMeta.tsx